<template>
  <b-container>
    <page-header name="Lista de Participantes Inelegívies">
      <b-button
        variant="primary"
        @click="newList"
      >
        <FeatherIcon icon="PlusIcon"/>
        &nbsp;<span class="text-nowrap">Adicionar</span>
      </b-button>
    </page-header>
    <Grid
      :fields="fields"
      :items="items"
      edit-button-label="edit"
      new-button-label="new"
      :show-search="false"
      @onChangePage="getList"
    >
      <template v-slot:search>
        <b-row class="p-0 pl-1">
          <b-col
            md="10"
            class="p-0 pr-1"
          >
            <b-form-input
              v-model="search.search"
              class="filter-input"
              placeholder="Pesquisar por Nome"
              name="nome"
            />
          </b-col>
          <b-col
            sm="12"
            md="2"
          >
            <b-button
              variant="secondary"
              type="button"
              @click="getList"
            >
              <FeatherIcon icon="SearchIcon" />
              <span
                class="text-nowrap"
              />
            </b-button>
          </b-col>
        </b-row>
      </template>
      <template
        #cell(action)="data"
        style="width: 20%"
      >
        <div class="px-1 text-center">
          <i2-icon-button
            icon="EditIcon"
            variant="outline-primary"
            class="mr-1"
            @click="setCurrentList(data.item)"
          />
          <i2-icon-button
            fa-icon="fa-trash"
            variant="outline-danger"
            class="mr-1"
            @click="onDelete(data.item)"
          />
          <i2-icon-button
            icon="EyeIcon"
            variant="outline-info"
            class="mr-1"
            @click="showParticipants(data.item)"
          />
        </div>
      </template>
    </Grid>
    <inelegible-form
      :is-active.sync="isActivated"
      :list="currentList"
      @onSave="onSave()"
      @onCancel="onCancel()"
    />
    <ineligible-participants
      :is-active.sync="isShowParticipants"
      :list="currentListUuid"
      :title="currentTitle"
      @onClose="onCloseParticipants"
      @onSave="onUpdateParticipants"
      @onDelete="onUpdateParticipants"
    />

  </b-container>

</template>

<script>

import InelegibleForm from '@/views/ineligible-list/InelegibleForm.vue'
import IneligibleParticipants from '@/views/ineligible-list/IneligibleParticipants'

export default {
  name: 'IneligibleList',
  components: { IneligibleParticipants, InelegibleForm },
  data() {
    return {
      search: {
        search: '',
      },
      fields: [
        {
          key: 'name',
          label: 'Nome',
          class: 'w-50',
        },
        {
          key: 'participants',
          label: 'Número de Participantes',
          class: 'w-30',
        },
        {
          key: 'action',
          label: 'Ações',
          class: 'w-20 text-center',
        },
      ],
      currentList: '',
      currentListUuid: '',
      participantsInList: [],
      items: [],
      currentPromotion: {},
      isActivated: false,
      currentTitle: '',
      isShowParticipants: false,
    }
  },
  async mounted() {
    const promotion = this.$user.getCurrentPromotion()
    if (!promotion) {
      await this.$router.push(`/change-promotions?ref=${this.$route.path}`)
      return
    }
    await this.getList(1)
  },
  methods: {
    newList() {
      this.isActivated = true
    },
    async getList(page) {
      this.items = await this.$search.get(
        'ineligible-lists',
        page,
        this.search,
        '',
      )
    },

    setCurrentList(list) {
      this.isActivated = true
      this.currentList = list.uuid
    },

    onDelete(list) {
      const route = `ineligible-lists/${list.uuid}`
      this.$apiDelete.execute(
        route,
        'Confirma a exclusão da lista',
        'Excluir lista',
        () => {
          this.$notify.success(`lista ${list.name} removida com sucesso.`)
          this.getList()
        },
      )
    },
    onSave() {
      this.getList(1)
      this.isActivated = false
      this.currentList = ''
    },
    onCancel() {
      this.isActivated = false
      this.currentList = ''
    },
    showParticipants(item) {
      this.isShowParticipants = true
      this.currentListUuid = item.uuid
      this.currentTitle = `Participantes em ${item.name}`
    },
    onCloseParticipants() {
      this.isShowParticipants = false
      this.currentListUuid = ''
      this.getList(1)
    },
    onUpdateParticipants() {
      this.getList(1)
    },
  },
}
</script>

<style scoped>

</style>
